export const emptyState_style = {
  rootSx: {},
  emptyStateSx: {
    textAlign: 'center',
  },
  mainHeadSx: {
    fontWeight: 600,
    pb: 1,
    color: 'text.primary',
  },
  subHeadSx: {
    fontSize: '12px',
    fontWeight: 400,
    color: 'text.secondary',
  },
};
